import React from "react"
import {Outlet, useLocation, useOutletContext} from "react-router-dom"
import Guides from "./Guides"

function Profile() {

    const oc = useOutletContext().oc
    const locationArray = useLocation().pathname.split('/').filter((char) => char !== '')
    const accountLocation = locationArray[0].replace(/@/g, '')
    const viewingID = useOutletContext().viewingID

    return (
        <div id="profile">
            <div id={oc.account == accountLocation ? "userbar" : "userbarunderline"}>
                <h2 id="username">{accountLocation}</h2>
                {/* <h2 id="userlvl">lvl 1 (////------) 2</h2> */}
            </div>
            {oc.account != accountLocation && <Guides/>}
            <Outlet context={{oc: oc, viewingID: viewingID}}/>
        </div>
    )
}

export default Profile;
